import { TextInput, TextInputProps } from '@utilitywarehouse/hearth-react';
import InputmaskImport from 'inputmask';
import { useEffect, useRef } from 'react';
import type { ChangeEvent } from 'react';

type MaskedInputProps = {
  mask: string;
  onChange(value: string): void;
} & Omit<TextInputProps, 'onChange'>;

// @ts-expect-error due to vite v8 rolldown handling of CJS modules
// (fixed in 5.0.10 hopefully https://github.com/RobinHerbots/Inputmask/issues/2884)
const Inputmask = InputmaskImport.default ?? Inputmask;
const MaskedInput = ({ mask, onChange, ...props }: MaskedInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const im = new Inputmask(mask, {
      jitMasking: true,
      autoUnmask: true,
      placeholder: props?.placeholder,
      groupSeparator: ',',
      rightAlign: false,
    });
    inputRef.current && im.mask(inputRef.current);
  }, [mask, props?.placeholder]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
    onChange(e?.target?.value);

  return <TextInput {...props} onChange={handleChange} ref={inputRef} />;
};

export { MaskedInput };
